import { IRowNode } from 'ag-grid-community'
import { useCallback, useMemo, useState } from 'react'
import { ProjectPlanNewRow } from '../projectPlanNew'

export type WbsItemEditPopperAnchor = {
  getBoundingClientRect: () => DOMRect
}

export const useWbsItemEditPopper = () => {
  const [anchorEl, setAnchorEl] = useState<
    WbsItemEditPopperAnchor | undefined
  >()
  const [rowNode, setRowNode] = useState<
    IRowNode<ProjectPlanNewRow> | undefined
  >()

  const open = useCallback(
    (
      node: IRowNode<ProjectPlanNewRow>,
      event: MouseEvent | Touch,
      ganttBarElement?: HTMLElement
    ) => {
      const { clientX, clientY } = event
      setAnchorEl({
        getBoundingClientRect: () => {
          const barRect = ganttBarElement?.getBoundingClientRect()
          return new DOMRect(
            clientX,
            barRect?.top ?? clientY,
            0,
            barRect?.height ?? 0
          )
        },
      })
      setRowNode(node)
    },
    []
  )

  const close = useCallback(() => {
    setAnchorEl(undefined)
    setRowNode(undefined)
  }, [])

  return useMemo(
    () => ({
      anchorEl,
      rowNode,
      open,
      close,
    }),
    [anchorEl, rowNode, open, close]
  )
}
